import { ResultOf } from "gql.tada";
import { RoutingSectionById } from "@queries/entries/RoutingSectionById";
import { GetStartedRoutingSection } from "./GetStartedRoutingSection";
import { StillWatchingRoutingSection } from "./StillWatchingRoutingSection";
import { normalizeVariant } from "@utils/textUtils";

type RoutingSectionEntry = ResultOf<typeof RoutingSectionById>;

export const RoutingSection = ({ entry }: { entry: RoutingSectionEntry }) => {
  const variant = normalizeVariant(entry.routingSection?.variant);

  switch (variant) {
    case 'video-cta':
      return <StillWatchingRoutingSection entry={entry} />;

    case 'image-auto-height':
      return <GetStartedRoutingSection entry={entry} />;

    default:
      // "form-cta" and any unrecognized variants render as GetStartedRoutingSection
      return <GetStartedRoutingSection entry={entry} />;
  }
};
